<style>
  .sexy_lineDiv {
    margin-top: 20px;
  }

  .sexy_line {
    display: block;
    border: none;
    color: black;
    height: 2px;
    background: white;
    background: -webkit-gradient(radial, 50% 50%, 0, 50% 50%, 350, from(#fff), to(#000));
  }
</style>


<div class="col-md-12">
<div data-active-color="white" data-background-color="purple-bliss" data-image="../../assets/img/sidebar-bg/01.jpg"  class="app-sidebar">

  <div class="sidebar-header">
    <div class="logo clearfix">
      <a href="index.html" class="logo-text float-left">
        <div class="logo-img">
          <img style="width: auto; height: 70px;" src="../../assets/img/logos/Logo.png" />
        </div>
        <span class="text align-middle">&nbsp;&nbsp;&nbsp;&nbsp; Cloud </span>
      </a>
    </div>
  </div>

  <div class="sexy_lineDiv">
    <span class="sexy_line"></span>
  </div>

  <div class="sidebar-content">
    <div class="nav-container">
      <ul id="main-menu-navigation" data-menu="menu-navigation" data-scroll-to-active="true"
        class="navigation navigation-main">
        <li class="nav-item" routerLinkActive="active">
          <a [routerLink]="['/Home']"><i class="ft-home"></i><span data-i18n="" class="menu-title">Home</span></a>
        </li>

        <li class="nav-item" routerLinkActive="active">
          <a [routerLink]="['/UserManage']"><i class="ft-life-buoy"></i><span data-i18n="" class="menu-title">User
              Manage</span></a>
        </li>



        <li class="nav-item" routerLinkActive="active">
          <a [routerLink]="['/LogManage']"><i class="ft-edit"></i><span data-i18n="" class="menu-title">Log
              Manage</span></a>
        </li>

        <li class="nav-item" routerLinkActive="active">
          <a [routerLink]="['/DeviceManage']"><i class="ft-activity"></i><span data-i18n="" class="menu-title">Device
              Manage</span></a>
        </li>

        <li class="nav-item" routerLinkActive="active">
          <a [routerLink]="['/RealTimeLog']"><i class="ft-box"></i><span data-i18n="" class="menu-title">Real Time
              Log</span></a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a [routerLink]="['/RealTimeEnroll']"><i class="ft-cloud"></i><span data-i18n="" class="menu-title">Real
              Time Enroll</span></a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a [routerLink]="['/Migration']"><i class="ft-anchor"></i><span data-i18n=""
              class="menu-title">Migration</span></a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a [routerLink]="['/Download']"><i class="ft-command"></i><span data-i18n="" class="menu-title">Download
              Users</span></a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a [routerLink]="['/Import']"><i class="ft-command"></i><span data-i18n="" class="menu-title">Import
              Users</span></a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a [routerLink]="['/Generate']"><i class="ft-command"></i><span data-i18n="" class="menu-title">Generate</span></a>
        </li>



      </ul>
    </div>
  </div>

  <div class="sidebar-background"></div>

</div>
<nav class="navbar navbar-expand-lg navbar-light bg-faded header-navbar">
  <div class="container-fluid">
    <div class="navbar-header">

    </div>
    <div >
    <div class="navbar-container">
      <div id="navbarSupportedContent" class="collapse navbar-collapse float-right">
        <ul class="navbar-nav">

          <li class="dropdown nav-item"><a id="dropdownBasic3" href="#" data-toggle="dropdown"
              class="nav-link position-relative dropdown-toggle"><i
                class="ft-user font-medium-3 blue-grey darken-4"></i>
              <p class="d-none">User Settings</p>
            </a>
            <div ngbdropdownmenu="" aria-labelledby="dropdownBasic3"
              class="dropdown-menu text-left dropdown-menu-right">

              <a (click)="LogOut()" class="dropdown-item"><i class="ft-power mr-2"></i><span>Logout</span></a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  </div>
</nav>
<!-- Navbar (Header) Ends-->
</div>
